var map = {
	"./cerulean.png": "c4d7",
	"./cosmo.png": "7c87",
	"./cyborg.png": "b327",
	"./darkly.png": "95a2",
	"./flatly.png": "f3f6",
	"./journal.png": "b565",
	"./litera.png": "83e1",
	"./lumen.png": "3742",
	"./lux.png": "c144",
	"./materia.png": "279d",
	"./minty.png": "d66a",
	"./morph.png": "65d9",
	"./pulse.png": "a1a4",
	"./quartz.png": "cf58",
	"./sandstone.png": "a02a",
	"./simplex.png": "fef6",
	"./sketchy.png": "3210",
	"./slate.png": "e7dc",
	"./solar.png": "78e9",
	"./spacelab.png": "d936",
	"./superhero.png": "35be",
	"./united.png": "4077",
	"./vapor.png": "c291",
	"./yeti.png": "6e4c",
	"./zephyr.png": "f200"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1926";